import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

import Icon from '../Common/Icon';

import styles from './styles';

const toWords = (relativeTo) => {
  switch (relativeTo) {
    case 'origin':
      return 'Origin';
    case 'destination':
      return 'Destination';
    default:
      return 'Custom';
  }
};

class StagesTable extends Component {
  static propTypes = {
    stages: PropTypes.array.isRequired,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
  };

  state = {};

  renderStage = (stage) => {
    return (<TableRow key={stage.id} selectable={false}>
      <TableRowColumn style={styles.iconCol}>
        <Icon name={stage.icon || 'barcode'} style={styles.icon}/>
      </TableRowColumn>
      <TableRowColumn style={styles.nameCol}>{stage.name}</TableRowColumn>
      <TableRowColumn style={styles.relativeToCol}>{toWords(stage.relativeTo)}</TableRowColumn>
      <TableRowColumn style={styles.qualityControlCol}>{stage.qualityControl ? 'Yes' : 'No'}</TableRowColumn>
      <TableRowColumn style={styles.actionCol}>
        {/*<IconButton tooltip="Edit" tooltipPosition="bottom-center" onClick={() => this.handleEditStage(stage)}>*/}
          {/*<FontIcon className="material-icons">edit</FontIcon>*/}
        {/*</IconButton>*/}
        {/*<IconButton tooltip="Remove" tooltipPosition="bottom-center" onClick={() => this.handleRemoveStage(stage)}>*/}
          {/*<FontIcon className="material-icons">delete</FontIcon>*/}
        {/*</IconButton>*/}
      </TableRowColumn>
    </TableRow>);
  };

  render() {
    const { stages } = this.props;
    if (!stages) {
      return null;
    }

    return (<Table selectable={false}>
      <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
        <TableRow>
          <TableHeaderColumn style={styles.iconCol}></TableHeaderColumn>
          <TableHeaderColumn style={styles.nameCol}>Name</TableHeaderColumn>
          <TableHeaderColumn style={styles.relativeToCol}>Relative To</TableHeaderColumn>
          <TableHeaderColumn style={styles.qualityControlCol}>Quality Control</TableHeaderColumn>
          <TableHeaderColumn style={styles.actionCol}></TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        {stages.map(this.renderStage)}
      </TableBody>
    </Table>);
  }

}

export default StagesTable;



// WEBPACK FOOTER //
// ./src/components/StagesTable/index.js